import "../index.css";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  IconButton,
  Row,
  Tooltip,
  Typography,
} from "@/ui-kit";
import { AddressUtils } from "@/utils/address";
import { PencilIcon } from "lucide-react";
import type { IServiceArea } from "@/types/common";

type IProps = {
  serviceAreas: IServiceArea[];
  onEdit?: () => void;
};

export const ServiceAreasCard = ({ serviceAreas, onEdit }: IProps) => {
  const { t } = useTranslation();

  return (
    <Card className="profile-card" variant="layer1">
      <CardContent>
        <Row gap={24} alignmentVertical="top">
          <div className="profile-card__details">
            <Row gap={12}>
              <Typography
                as="h3"
                weight="bold"
                variant="h3"
                color="text-primary"
                text={t("label.service_areas")}
              />

              {onEdit && (
                <div className="profile-card__actions">
                  <Tooltip content={t("action.edit")} placement="bottom-end">
                    <IconButton
                      size="sm"
                      variant="ghost"
                      color="layer2"
                      content={<PencilIcon />}
                      onClick={onEdit}
                      aria-label={t("action.edit")}
                    />
                  </Tooltip>
                </div>
              )}
            </Row>

            <div className="profile-card__section">
              {serviceAreas.map((serviceArea, i: number) => {
                const address = AddressUtils.format(serviceArea.address);
                return (
                  <Typography
                    key={i}
                    variant="headline"
                    color="text-primary"
                    text={address}
                  />
                );
              })}
            </div>
          </div>
        </Row>
      </CardContent>
    </Card>
  );
};
